export default __webpack_public_path__ + "static/media/INSE.e86bf239.png";